'use client';

import { notNull } from "@/app/lib/common/not-null";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import Section from "@/app/features/shared/snap-section/Section";
import SlideshowIntroV2 from "@/app/__to_be_integrated/_____components/_NEW/intros/slideshow/SlideshowIntroV2";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";
import { Divider } from "@mui/material";
import { DetailSectionEditable } from "@/app/features/shared/detail-section";
import RelatedInfosView from "@/app/features/shared/related-infos/ui/RelatedInfos.public";
import { DetailEditable } from "@/app/features/shared/types/types";
import { useSiteEducationEditor } from "@/app/features/sites/education/contexts/SiteEducationEditorContext";
import { RelatedInfo } from "@/app/lib/generated/graphql-types";

export default function EducationEditable() {

    const { editable, updateEditable } = useSiteEducationEditor();

    const detailImages = editable?.details
        .filter(notNull)
        .filter((detail) => !!detail.image)
        .map((detail) => detail.image!)
        .filter(notNull) || []

    function updateDetailByIndex(indexToUpdate: number, partialDetail: Partial<DetailEditable>) {
        updateEditable({
            details: editable?.details.filter(notNull).map((detail, index) => {
                return index === indexToUpdate
                    ? { ...detail, ...partialDetail }
                    : detail

            })
        })
    }

    return (
        <SnapSectionsContainer>
            <Section>
                <SlideshowIntroV2 title={editable?.title || ''} subtitle={editable?.subtitle} images={detailImages} />
            </Section>

            <IntroAnchor />
            {editable?.details.filter(notNull).map((detail, index) => (
                <span key={index}>
                    <Divider sx={{ m: 4 }} />
                    <DetailSectionEditable
                        data={detail}
                        alignment={index % 2 === 0 ? "row" : "row-reverse"}
                        onTitleChange={(title) => updateDetailByIndex(index, { title })}
                        onSubtitleChange={(subtitle) => updateDetailByIndex(index, { subtitle })}
                        onDescriptionChange={(description) => updateDetailByIndex(index, { description })}
                        onImageChange={(image) => updateDetailByIndex(index, { image })}
                    />
                </span>
            ))}

            <RelatedInfosView relatedInfos={(editable?.relatedInfos.filter(notNull) || []) as RelatedInfo[]} />

        </SnapSectionsContainer>
    )
}
